import { IFormikInputIProps } from "@faire/retailer-visitor-shared/components/Form/types";
import { Input } from "@faire/web--source/slate/Input";
import { useField } from "formik";
import React, { ChangeEvent, useCallback } from "react";

export const FormikInput: React.FC<IFormikInputIProps> = ({
  ref,
  name,
  trackChange,
  blockErrorMsg,
  ...props
}) => {
  const [{ onChange, onBlur, ...field }, meta, { setTouched }] = useField(name);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (!e.target.value && !props.shouldNotModifyTouchedOnClear) {
        setTouched(false);
      }
      onChange(e);
    },
    [onChange, props.shouldNotModifyTouchedOnClear, setTouched]
  );

  const handleBlur = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      trackChange?.(name, e.target.value);
      onBlur(e);
    },
    [name, onBlur, trackChange]
  );

  /*
      if we want to display a custom error message (something with JSX),
      we dont want to show the error message from formik field
    */
  const errorString = blockErrorMsg ? !!meta.error : meta.error;

  return (
    <Input
      ref={ref}
      {...props}
      {...field}
      error={meta.touched && errorString}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};
